import React, { useState } from 'react';
import { PropTypes } from 'prop-types';

import { FormLabel } from '../../../../elements';
import { StyledTextarea } from '../../../../styles';
import AlertDialog from '../../AlertDialog';

const UpdateStatusModal = ({
  confirmHandler, dismissHandler, modal: { status, items, open },
}) => {
  const [comment, updateComment] = useState('');

  const modalConfirmHandler = () => {
    confirmHandler(items, status, comment);
    updateComment('');
  };

  const modalDismissHandler = () => {
    dismissHandler();
    updateComment('');
  };

  const commentChangeHandler = (event) => {
    updateComment(event.target.value);
  };

  return (
    <AlertDialog
      title={`${status === 'APPROVED' ? 'Approve' : 'Disapprove'} & Confirm`}
      open={!!open}
      confirmTitle="Confirm"
      onConfirmation={modalConfirmHandler}
      onDismiss={modalDismissHandler}
    >
      <div className="FormRowInline">
        <FormLabel title="Comment" labelAbove>
          <StyledTextarea onChange={commentChangeHandler} value={comment} data-testid="status-comment" />
        </FormLabel>
      </div>
    </AlertDialog>
  );
};

UpdateStatusModal.propTypes = {
  modal: PropTypes.shape({
    open: PropTypes.bool,
    status: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    ),
  }),
  confirmHandler: PropTypes.func,
  dismissHandler: PropTypes.func,
};

export default UpdateStatusModal;
